<template>
  <div class="itemlist">
      <h1>Administrator Menu</h1>
        <v-spacer/>
      <v-layout row wrap>
          <v-btn @click="$router.back()"><v-icon>arrow_back</v-icon>Back</v-btn>
          <v-spacer></v-spacer>
          <v-switch v-model="showOtp" label="One Time Codes"></v-switch>
          <v-switch v-model="showContrib" label="Contributor Setup"></v-switch>
      </v-layout>
      <hr />
      <OneTimeCodes v-if="showOtp"></OneTimeCodes>
      <ContributorSetup v-if="showContrib"></ContributorSetup>

</div>

</template>

<script>
import {mapState} from 'vuex'
// import firebase from 'firebase/app'

//import utils from '../utils.js'

import OneTimeCodes from '../components/OneTimeCodes.vue'
import ContributorSetup from '../components/ContributorSetup.vue'

export default {
  name: 'AdminMenu',
  components: {
      OneTimeCodes, ContributorSetup
  },
  data () {
    return {
        showOtp: false,
        showContrib: false,

    }
  },
  computed: {
    ...mapState({
    }),


  },
  mounted: function () {
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.itemlist {
  width: 100%;
}

</style>
